<template>
    <el-dialog
        class="repairclass leader-dialog"
        :title="dialogtitle"
        :visible.sync="returnShow"
        :close-on-click-modal="false"
        @close="closeDialog"
        width="1000px"
    >
        <el-scrollbar style="height: 400px">
            <el-form
                :rules="returnFormRules"
                :model="returnForm"
                ref="returnForm"
                class="leader-style-form"
            >
                <div style="margin-right: 20px">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item
                                label="到达现场时间"
                                :label-width="formLabelWidth"
                                prop="arrive_time"
                            >
                                <el-date-picker
                                    v-model="returnForm.arrive_time"
                                    type="datetime"
                                    style="width: 100%;"
                                    :disabled="isBackFill"
                                    placeholder="选择日期"
                                    :default-value="timeNow"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    @change="gettime"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                label="抢修完成时间"
                                :label-width="formLabelWidth"
                                prop="finish_time"
                            >
                                <el-date-picker
                                    v-model="returnForm.finish_time"
                                    type="datetime"
                                    style="width: 100%;"
                                    :disabled="isBackFill"
                                    placeholder="选择日期"
                                    :default-value="timeNow"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    @change="gettime"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item
                                label="停电时间"
                                :label-width="formLabelWidth"
                                prop="power_cut_time"
                            >
                                <el-date-picker
                                    v-model="returnForm.power_cut_time"
                                    type="datetime"
                                    style="width: 100%"
                                    :disabled="isBackFill"
                                    placeholder="选择日期"
                                    :default-value="timeNow"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    @change="getTable"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                label="恢复送电时间"
                                :label-width="formLabelWidth"
                                prop="power_recovery_time"
                            >
                                <el-date-picker
                                    v-model="returnForm.power_recovery_time"
                                    type="datetime"
                                    style="width: 100%"
                                    :disabled="isBackFill"
                                    placeholder="选择日期"
                                    :default-value="timeNow"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    @change="getTable"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="抢修用时" :label-width="formLabelWidth">
                                <el-input
                                    maxlength="20"
                                    autocomplete="off"
                                    v-model="userTime"
                                    :disabled="true"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="报修单号" :label-width="formLabelWidth">
                                <el-input
                                    maxlength="20"
                                    autocomplete="off"
                                    :disabled="true"
                                    v-model="returnForm.report_repair_no"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="报修人" :label-width="formLabelWidth">
                                <el-input
                                    maxlength="20"
                                    autocomplete="off"
                                    v-model="returnForm.reporter"
                                    :disabled="true"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="报修人电话" :label-width="formLabelWidth">
                                <el-input
                                    maxlength="20"
                                    autocomplete="off"
                                    :disabled="true"
                                    v-model="returnForm.reporter_phone"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item
                                label="停电范围"
                                :label-width="formLabelWidth"
                                prop="power_cut_area"
                            >
                                <el-input
                                    type="textarea"
                                    :rows="4"
                                    :disabled="isBackFill"
                                    placeholder="请输入内容"
                                    v-model="returnForm.power_cut_area"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>

                <el-card class="leader-card" style="margin-top: 50px">
                    <div slot="header" class="clearfix theme_font_color">
                        <span>故障情况</span>
                    </div>
                    <div class="text item">
                        <el-scrollbar style="height:200px">
                            <el-table
                                v-bind:data="returnForm.repairTrees"
                                border
                                style="width: 100%"
                                class="leader-style-table"
                            >
                                <el-table-column prop="tree_name" label="设备名称" align="center"></el-table-column>
                                <el-table-column prop="reason" label="故障原因" align="center">
                                    <template slot-scope="scope">
                                        <el-input
                                            class="inputclass"
                                            v-model="scope.row.reason"
                                            :disabled="isBackFill"
                                            placeholder="请输入故障原因"
                                        ></el-input>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-scrollbar>
                    </div>
                </el-card>

                <el-card class="leader-card" style="margin-top: 20px;">
                    <div slot="header" class="clearfix theme_font_color">
                        <span>更换配件</span>
                        <el-button
                            style="float: right;"
                            type="primary"
                            size="small"
                            v-if="!isBackFill"
                            @click="addEmptyItem"
                        >新增</el-button>
                    </div>
                    <div class="text item">
                        <el-scrollbar style="height:200px">
                            <el-table
                                :data="returnForm.repairParts"
                                highlight-current-row
                                border
                                max-height="200px"
                                style="width: 100%"
                                ref="tableRef"
                                class="leader-style-table"
                            >
                                <el-table-column label="消耗配件名称" align="center" width="200">
                                    <template slot-scope="scope">
                                        <el-form-item
                                            :prop="
                                                'repairParts.' +
                                                scope.$index +
                                                '.parts_name'
                                            "
                                            :rules="[
                                                {
                                                    required: true,
                                                    message:
                                                        '请输入消耗配件名称',
                                                },
                                            ]"
                                        ></el-form-item>
                                        <el-input
                                            v-model="scope.row.parts_name"
                                            placeholder="请输入消耗配件名称"
                                            :disabled="isBackFill"
                                        ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="型号" align="center">
                                    <template slot-scope="scope">
                                        <el-form-item
                                            :prop="
                                                'repairParts.' +
                                                scope.$index +
                                                '.parts_model'
                                            "
                                            :rules="[
                                                {
                                                    required: true,
                                                    message: '请输入型号',
                                                },
                                            ]"
                                        ></el-form-item>
                                        <el-input
                                            v-model="scope.row.parts_model"
                                            placeholder="请输入型号"
                                            :disabled="isBackFill"
                                        ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="数量" align="center">
                                    <template slot-scope="scope">
                                        <el-form-item
                                            :prop="
                                                'repairParts.' +
                                                scope.$index +
                                                '.parts_num'
                                            "
                                            :rules="[
                                                {
                                                    required: true,
                                                    message: '请输入数量',
                                                },
                                            ]"
                                        ></el-form-item>
                                        <el-input
                                            v-model="scope.row.parts_num"
                                            placeholder="请输入数量"
                                            :disabled="isBackFill"
                                            v-Int.integer
                                        ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="单位" align="center">
                                    <template slot-scope="scope">
                                        <el-form-item
                                            :prop="
                                                'repairParts.' +
                                                scope.$index +
                                                '.parts_unit'
                                            "
                                            :rules="[
                                                {
                                                    required: true,
                                                    message: '请输入单位',
                                                },
                                            ]"
                                        ></el-form-item>
                                        <div>
                                            <el-input
                                                v-model="scope.row.parts_unit"
                                                placeholder="请输入单位"
                                                class="el-input"
                                                :disabled="isBackFill"
                                            ></el-input>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="修改"
                                    align="center"
                                    width="150"
                                    v-if="!isBackFill"
                                >
                                    <template slot-scope="scope">
                                        <div>
                                            <el-button
                                                type="danger"
                                                size="small"
                                                v-if="scope.row.seq_num != '0'"
                                                @click="deleteItem(scope.row)"
                                            >删除</el-button>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-scrollbar>
                    </div>
                </el-card>
                <div style="margin-right: 20px; margin-top: 20px;">
                    <el-form-item label="抢修结果" :label-width="formLabelWidth" prop="result">
                        <el-input
                            type="textarea"
                            :rows="2"
                            :disabled="isBackFill"
                            placeholder="请输入抢修结果"
                            v-model="returnForm.result"
                        ></el-input>
                    </el-form-item>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="用户确认单" :label-width="formLabelWidth">
                                <div v-if="isBackFill">
                                    <img :src="returnForm.qrd_path" class="avatar" />
                                </div>
                                <div v-else>
                                    <el-upload
                                        class="avatar-uploader"
                                        action
                                        :http-request="uploadFile1"
                                        list-type="picture-card"
                                        :file-list="qxFileImgs"
                                        :on-remove="handleRemove1"
                                        :class="{ disabled: uploadDisabled }"
                                        accept=".jpg, , jpeg, .png, .gif, .bmp"
                                    >
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="附件" :label-width="formLabelWidth">
                                <div v-if="isBackFill">
                                    <img :src="returnForm.fj_path" class="avatar" />
                                </div>
                                <div v-else>
                                    <el-upload
                                        class="avatar-uploader"
                                        action
                                        :http-request="uploadFile2"
                                        list-type="picture-card"
                                        :file-list="qxFileImgs"
                                        :on-remove="handleRemove2"
                                        :class="{ disabled: uploadDisabled2 }"
                                        accept=".jpg, , jpeg, .png, .gif, .bmp"
                                    >
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                </div>
                                <!--                            <el-input maxlength="20" autocomplete="off" v-model="returnForm.file"></el-input>-->
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
        </el-scrollbar>
        <div slot="footer" v-if="!isBackFill" class="dialog-footer">
            <el-button @click="returnShow = false" class="leader-common-button">取消</el-button>
            <el-button
                type="primary"
                @click="addBackfill"
                :loading="this.$store.state.btnType"
                class="leader-common-button"
            >保存</el-button>
        </div>
    </el-dialog>
</template>
<script>
import * as api from '../api/index';
import utils from '@/utils/utils';
import Bus from '@/utils/eventBus.js';
export default {
    inject: ['reload'],
    props: {
        returnShow: {
            type: Boolean,
        },
        errorTableData1: {
            type: Array,
        },
        chooseRow: {
            type: Object,
        },
    },
    computed: {
        uploadDisabled: function () {
            return this.returnForm.qrd_id.length > 0;
        },
        uploadDisabled2: function () {
            return this.returnForm.fj_id.length > 0;
        },
    },
    watch: {
        errorTableData1() {
            if ('0' == this.chooseRow.backfill_state) {
                //未回填
                (this.dialogtitle = '抢修回填'), (this.isBackFill = false);

                this.returnForm.repairTrees = [];
                if (this.chooseRow.tree_names != null) {
                    let namelist = this.chooseRow.tree_names.split(',');
                    console.log(namelist);
                    let idslist = this.chooseRow.tree_ids.split(',');
                    for (var i = 0; i < namelist.length; i++) {
                        let item = {
                            tree_name: namelist[i],
                            tree_id: idslist[i],
                            reason: '',
                        };
                        this.returnForm.repairTrees.push(item);
                    }
                }
                this.returnForm.usersName = this.chooseRow.leader_name;
                this.returnForm.rush_repair_id = this.chooseRow.rush_repair_id;
                this.returnForm.reporter = this.chooseRow.reporter;
                this.returnForm.reporter_phone = this.chooseRow.reporter_phone;
                this.returnForm.report_repair_no = this.chooseRow.report_repair_no;
                // this.returnForm.phoneNumber=this.chooseRow.rush_repair_id
            } else {
                //已回填
                (this.dialogtitle = '查看回填'), (this.isBackFill = true);
                //获取回填数据

                this.getBackfill();
            }
        },
    },
    data() {
        return {
            dialogtitle: '抢修回填',
            formLabelWidth: '120px',
            returnShow: true,
            activeName: 'second',
            returnFormRules: {
                arrive_time: [
                    {
                        required: true,
                        message: '请选择到达现场时间',
                        trigger: 'blur',
                    },
                ],
                finish_time: [
                    {
                        required: true,
                        message: '请选择抢修完成时间',
                        trigger: 'blur',
                    },
                ],
                power_cut_time: [
                    {
                        required: true,
                        message: '请输入停电时间',
                        trigger: 'blur',
                    },
                ],
                power_recovery_time: [
                    {
                        required: true,
                        message: '请输入恢复送电时间',
                        trigger: 'blur',
                    },
                ],
                power_cut_area: [
                    {
                        required: true,
                        message: '请输入停电范围',
                        trigger: 'blur',
                    },
                ],
                result: [
                    {
                        required: true,
                        message: '请输入抢修结果',
                        trigger: 'blur',
                    },
                ],
                userConfirm: [
                    {
                        required: true,
                        message: '请选择用户确认单',
                        trigger: 'change',
                    },
                ],
                file: [
                    {
                        required: true,
                        message: '请选择附件',
                        trigger: 'change',
                    },
                ],
            },
            //新增弹窗数据块
            returnForm: {
                rush_repair_id: '',
                arrive_time: '',
                finish_time: '',
                power_cut_time: '',
                power_recovery_time: '',
                power_cut_area: '',
                report_repair_no: '',
                reporter: '',
                reporter_phone: '',
                result: '',

                qrd_id: '',
                fj_id: '',
                repairParts: [],
                repairTrees: [],

                //查看时数据
                fj_path: '',
                qrd_path: '',
            },
            userTime: '0小时',
            isBackFill: false,
        };
    },
    methods: {
        // 获取table列表
        addBackfill() {
            this.$refs['returnForm'].validate((valid) => {
                if (valid) {
                    api.addBackfill(this.returnForm).then((res) => {
                        if (res.error_code === '0') {
                            this.$message({
                                message: '回填成功！',
                                type: 'success',
                            });
                            //回填成功清空数据
                            this.returnForm.rush_repair_id = '';
                            this.returnForm.arrive_time = '';
                            this.returnForm.finish_time = '';
                            this.returnForm.power_cut_time = '';
                            this.returnForm.power_recovery_time = '';
                            this.returnForm.power_cut_area = '';
                            this.returnForm.report_repair_no = '';
                            this.returnForm.reporter = '';
                            this.returnForm.reporter_phone = '';
                            this.returnForm.result = '';
                            this.returnForm.qrd_id = '';
                            this.returnForm.fj_id = '';
                            this.returnForm.qrd_path = '';
                            this.returnForm.fj_path = '';
                            this.returnForm.repairParts = [];
                            this.returnForm.repairTrees = [];

                            //通知前页对话框关闭
                            this.returnShow = false;
                            this.$emit('update:returnShow', this.returnShow);
                            Bus.$emit('refresh', this.returnShow);
                        } else {
                            this.$message({
                                message: res.bus_json,
                                type: 'error',
                            });
                        }
                    });
                }
            });
        },
        // 获取table列表
        getBackfill() {
            api.getBackfill({
                rush_repair_id: this.chooseRow.rush_repair_id,
            }).then((res) => {
                if (res.error_code === '0') {
                    this.returnForm.rush_repair_id =
                        res.bus_json.rush_repair_id;
                    this.returnForm.arrive_time = res.bus_json.arrive_time;
                    this.returnForm.finish_time = res.bus_json.finish_time;
                    this.returnForm.power_cut_time =
                        res.bus_json.power_cut_time;
                    this.returnForm.power_recovery_time =
                        res.bus_json.power_recovery_time;
                    this.returnForm.power_cut_area =
                        res.bus_json.power_cut_area;
                    this.returnForm.report_repair_no =
                        res.bus_json.report_repair_no;
                    this.returnForm.reporter = res.bus_json.reporter;
                    this.returnForm.reporter_phone =
                        res.bus_json.reporter_phone;
                    this.returnForm.result = res.bus_json.result;
                    this.returnForm.qrd_id = res.bus_json.qrd_id;
                    this.returnForm.fj_id = res.bus_json.fj_id;
                    this.returnForm.qrd_path =
                        process.env.VUE_APP_3D_URL +
                        '/' +
                        res.bus_json.qrd_path;
                    this.returnForm.fj_path =
                        process.env.VUE_APP_3D_URL + '/' + res.bus_json.fj_path;
                    this.returnForm.repairParts = res.bus_json.repairParts;
                    this.returnForm.repairTrees = res.bus_json.repairTrees;
                }
            });
        },
        gettime() {
            if (
                '' === this.returnForm.arrive_time ||
                '' === this.returnForm.finish_time
            ) {
                this.userTime = '0小时';
            } else {
                this.userTime = utils.formatGap(
                    this.returnForm.arrive_time,
                    this.returnForm.finish_time
                );
            }
        },
        closeDialog() {
            //回填成功清空数据
            this.returnForm.rush_repair_id = '';
            this.returnForm.arrive_time = '';
            this.returnForm.finish_time = '';
            this.returnForm.power_cut_time = '';
            this.returnForm.power_recovery_time = '';
            this.returnForm.power_cut_area = '';
            this.returnForm.report_repair_no = '';
            this.returnForm.reporter = '';
            this.returnForm.reporter_phone = '';
            this.returnForm.result = '';
            this.returnForm.qrd_id = '';
            this.returnForm.fj_id = '';
            this.returnForm.qrd_path = '';
            this.returnForm.fj_path = '';
            this.returnForm.repairParts = [];
            this.returnForm.repairTrees = [];

            //关闭对话框
            this.returnShow = false;
            this.$emit('update:returnShow', this.returnShow);
            this.$emit('update:errorTableData1', this.errorTableData1);

            //清除验证
            if (this.$refs['returnForm']) {
                this.$refs['returnForm'].resetFields();
                this.$refs['returnForm'].clearValidate();
            }
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        addEmptyItem() {
            let emptyItem = {
                parts_name: '', //是否参与计算
                parts_model: '',
                parts_num: '',
                parts_unit: '', //是否必填
            };
            this.returnForm.repairParts.push(emptyItem);
        },
        //删除
        deleteItem(sth) {
            this.$confirm('确认删除这条数据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then((_) => {
                this.returnForm.repairParts.forEach(function (item, index, arr) {
                    if (item == sth) {
                        arr.splice(index, 1);
                    }
                });
            });
        },
        // 用户确认单上传
        uploadFile1(file) {
            const isLt2M = file.file.size / 1024 / 1024 < 1;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 1MB!,请重新上传！');
                return;
            }
            let formData = new FormData();
            formData.append('file', file.file);
            formData.append('file_type', '10');
            api.uploadAvatar(formData).then((res) => {
                if (res) {
                    this.returnForm.qrd_id = res.bus_json.file_id;
                    this.$message({
                        type: 'success',
                        message: res.error_msg,
                    });
                }
            });
        },
        handleRemove1(file) {
            this.returnForm.qrd_id = '';
        },
        handleRemove2(file) {
            this.returnForm.fj_id = '';
        },
        // 附件上传
        uploadFile2(file) {
            console.log(file);
            const isLt2M = file.file.size / 1024 / 1024 < 1;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 1MB!,请重新上传！');
                return;
            }
            let formData = new FormData();
            formData.append('file', file.file);
            formData.append('file_type', '20');
            api.uploadAvatar(formData).then((res) => {
                if (res) {
                    this.returnForm.fj_id = res.bus_json.file_id;
                    this.$message({
                        type: 'success',
                        message: res.error_msg,
                    });
                }
            });
        },
    },
};
</script>
<style lang="scss">
.repairclass {
    .theme_font_color {
        // @include font_color;
    }
    .inputclass {
        .el-input__inner {
            background-color: transparent !important;
            border: 1px solid #277ea3;
        }
    }

    .avatar-uploader {
        text-align: left;
        .el-upload--picture-card {
            width: 100px;
            height: 100px;
            line-height: 100px;
            background-color: transparent;
        }

        .el-upload-list--picture-card .el-upload-list__item {
            width: 100px;
            height: 100px;
        }
    }

    .disabled .el-upload--picture-card {
        display: none;
    }
}
</style>
